<div *sbPageAction>
  <div class="d-flex flex-row">
    <a *ngPermissions="permissionService.Permission.visitor_tracker_edit" class="btn btn-primary" (click)="editTracker()">
      <sb-icon icon="edit"></sb-icon>&nbsp;<span class="d-none d-sm-inline-block">
            {{'nav.network.tracker.editTracker' | translate}}</span>
    </a>
  </div>
</div>

<div class="d-flex flex-row-fluid w-100" [style.background-image]="'url(./assets/img/' + 'devicedetails-bg.jpg)'"
     style="height: 400px; background-size: cover; background-position: left 27%; border-radius: .4rem">
  <div class="d-flex align-items-center text-center flex-column justify-content-center h-100 w-100"
       style="position: relative;">
    <!-- <div class="overflow-hidden text-start" style="height: 100%;width: 100%;top: 0;position: absolute;">
            <div *ngFor="let icon of icons" [ngStyle]="icon.pos" class="icon-container">
                <fa-icon [icon]="icon.name"></fa-icon>
            </div>
        </div> -->

    <div class="d-flex justify-content-center text-center" style="margin-bottom: 1.3rem;">
      <div>
        <h2 style="color: #fdfeff;text-shadow: 0 0 10px #000;" class="font-weight-bolder">
          {{tracker?.name}}
          <ng-container *ngIf="tracker?.identifier">
            ({{tracker?.identifier}})
          </ng-container>
        </h2>
        <h6 style="color: #fdfeff; text-shadow: 0 0 5px #000;">{{ 'nav.network.tracker' | translate }}
          :&nbsp;{{ tracker?.id }}</h6>
      </div>
    </div>
    <sb-card>
      <div card-body>
        <div class="d-flex justify-content-between text-start">
          <div class="d-flex flex-row">
            <ng-container *ngFor="let trackerStatus of status; last as last;">
              <div class="d-flex align-items-center px-1" [ngClass]="!last ? 'border-dashed-right' : ''">
                <button ngbTooltip="{{ 'lang.globals.' + trackerStatus.type | translate }}" placement="top"
                        container="body"
                        style="box-shadow: 0 2px 4px 0 rgba(90,141,238,.5)" class="btn white"
                        [ngClass]="trackerStatus?.value ? 'green-bg' : 'grey-bg'">
                  <sb-icon *ngIf="trackerStatus?.value" icon="success">
                  </sb-icon>
                  <sb-icon *ngIf="!trackerStatus?.value" icon="error">
                  </sb-icon>
                  {{ 'lang.globals.' + trackerStatus.type | translate }}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>

<div class="px-0 px-sm-0 px-md-2 px-lg-4 px-xl-5 px-xxl-10 px-xxxl-10" style="margin-top: -100px">
  <div class="row">
    <div class="col-lg-12 col-xl-3">
      <sb-card>
        <div card-body>
          <ul class="nav-tabs nav sidenav">
            <li class="nav-item">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.trackerDetailsOverview"
                 [sbRouterLink]="util.RoutingID.trackerDetailsOverview"><span>
                  <sb-icon class="mr-3" icon="eye"></sb-icon>
                {{'nav.network.tracker.details.overview' | translate}}
                </span></a>
            </li>
            <li class="nav-item" *ngPermissions="permissionService.Permission.visitor_tracker_visitor_aggregation">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.trackerDetailsTrackedVisitors"
                 [sbRouterLink]="util.RoutingID.trackerDetailsTrackedVisitors"><span>
                  <sb-icon class="mr-3" icon="tracker"></sb-icon>
                {{'nav.network.tracker.details.visitors' | translate}}
                </span></a>
            </li>
          </ul>
        </div>
      </sb-card>
    </div>
    <div class="col-lg-12 col-xl-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
